<template>
  <div class="school-degree">
    <div v-if="$props.degree.name" class="text-center">
      <h2>{{ $props.degree.name }}</h2>
    </div>
    <div class="school-degree-school flex">
      <div v-if="$props.degree.logotype" class="school-degree-school-image flex">
        <div
          :class="[
            'school-degree-school-image-container flex',
            { [$props.degree.backgroundColor]: $props.degree.backgroundColor }
          ]"
        >
          <img
            :src="$props.degree.logotype"
            :alt="$t('aboutMe.altLabel', { element: $props.degree.school })"
            class="school-degree-school-image-container-tag"
          />
        </div>
      </div>
      <div class="school-degree-school-title text-center text-sm-left">
        <div
          v-if="$props.degree.href && $props.degree.school"
          class="school-degree-school-title-text"
        >
          <a
            v-if="$props.degree.href"
            :href="$props.degree.href"
            class="general-anchor decorated"
            target="_blank"
            rel="noreferrer,noopener"
          >
            <h3 class="school-degree-school-title-text-tag">
              <span>{{ $props.degree.school }}</span>
            </h3>
          </a>
          <h3 v-else class="school-degree-school-container-title">{{ $props.degree.school }}</h3>
        </div>
        <div v-if="$props.degree.date" class="school-degree-school-title-text text-lg-right">
          <h3 class="school-degree-school-title-text-tag">{{ $props.degree.date }}</h3>
        </div>
      </div>
    </div>
    <div v-if="$props.degree.grade" class="text-center text-sm-left">
      <h4 class="school-degree-grade">
        {{ $t("aboutMe.education.scoreLabel") }} {{ $props.degree.grade }}
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "SchoolDegree",
  props: {
    /*
     * @property - degree
     * Defines all content inside this component
     * $degree.name
     * $degree.school
     * $degree.href
     * $degree.logotype
     * $degree.backgroundColor
     * $degree.date
     * $degree.grade
     */
    degree: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.school-degree {
  border-top: 0.0625rem solid $main-green;
  padding: 1.5rem 0 3rem 0;

  &-school {
    flex-wrap: wrap;

    &-image {
      width: 100%;

      @include breakpoint($small) {
        flex: 0 0;
      }

      &-container {
        @include boxShadow(0.25, true, false);
        background-color: $white-raw;
        border: 0.0625rem solid $main-blue;
        border-radius: 0.45rem;
        height: 6.5rem;
        margin: auto;
        overflow: hidden;
        width: 6.5rem;

        &.black {
          background-color: $dark-gray;
          border: 0.0625rem solid $main-green;
        }

        &-tag {
          margin: auto;
          max-height: 95%;
          max-width: 95%;
        }
      }
    }

    &-title {
      width: 100%;

      @include breakpoint($small) {
        flex: 1 0;
        max-width: 100%;
        padding-left: 1rem;
      }

      @include breakpoint($large) {
        display: flex;
        flex-wrap: wrap;
      }

      &-text {
        width: 100%;

        @include breakpoint($large) {
          flex: 1 0;
          max-width: 100%;
        }

        &-tag {
          display: inline-block;
          margin: 0.75rem 0 0.25rem 0;

          @include breakpoint($small) {
            margin: 0.85rem 0 0 0;
          }

          @include breakpoint($large) {
            margin: 1.65rem 0 0 0;
          }
        }
      }
    }
  }

  &-grade {
    margin: 0.65rem 0;
  }
}
</style>
